import React, { useReducer } from 'react';

import SidebarContext from './SidebarContext';
import SidebarReducer from './SidebarReducer';

const SidebarState = (props) => {
    const initialState = {
        sidebar: {
            isShow: false,
        },
    }

    const [state, dispatch] = useReducer(SidebarReducer, initialState);

    const showSidebar = (isShow) => {
        dispatch({ type: "SHOW_SIDEBAR", payload: isShow });
    };

    return (
        <SidebarContext.Provider value={{
            sidebarState: state.sidebar,
            showSidebar
        }}>
            {props.children}
        </SidebarContext.Provider>
    )
}

export default SidebarState;
